const noResultsCourses = [
  {
    id: 387,
    title: "Introducción a Adobe Photoshop",
    teacher: "Carles Marsal",
    coverPath: "v1542625945/course-covers/000/000/387/387-original.jpg?1542625945",
  },
  {
    id: 404,
    title: "Creación y edición de contenido para Instagram Stories",
    teacher: "Mina Barrio",
    coverPath: "v1551722213/course-covers/000/000/404/404-original.jpg?1551722213",
  },
  {
    id: 304,
    title: "Introducción a After Effects",
    teacher: 'Carlos "Zenzuke" Albarrán',
    coverPath: "v1533713831/course-covers/000/000/304/304-original.jpg?1533713831",
  },
  {
    id: 470,
    title: "Desarrollo de un plan de medios digitales",
    teacher: "Foncho Ramírez-Corzo",
    coverPath: "v1553799647/course-covers/000/000/470/470-original.jpg?1553799647",
  },
  {
    id: 499,
    title: "Introducción a Adobe Illustrator",
    teacher: "Aarón Martínez",
    coverPath: "v1556623033/course-covers/000/000/499/499-original.jpg?1556623033",
  },
  {
    id: 381,
    title: "Técnicas de ilustración para desbloquear tu creatividad",
    teacher: "Adolfo Serra",
    coverPath: "v1555006907/course-covers/000/000/381/381-original.jpg?1555006907",
  },
  {
    id: 208,
    title: "Iniciación al diseño de interiores",
    teacher: "Masquespacio",
    coverPath: "v1510161191/course-covers/000/000/208/208-original.jpg?1510161191",
  },
  {
    id: 137,
    title: "Tipografía y Branding: Diseño de un logotipo icónico",
    teacher: "Quique Ollervides",
    coverPath: "v1476782428/course-covers/000/000/137/137-original.jpg?1476782428",
  },
  {
    id: 303,
    title: "Pintar con hilo: técnicas de ilustración textil",
    teacher: "Gimena Romero",
    coverPath: "v1540824880/course-covers/000/000/303/303-original.jpg?1540824880",
  },
  {
    id: 537,
    title: "BASICS: Adobe Premiere",
    teacher: "Juanmi Cristóbal",
    coverPath: "v1558447617/course-covers/000/000/537/537-original.jpg?1558447617",
  },
  {
    id: 151,
    title: "Copywriting: define el tono de tu marca personal",
    teacher: "Carla Gonzalez",
    coverPath: "v1480001842/course-covers/000/000/151/151-original.jpg?1480001842",
  },
  {
    id: 138,
    title: "Dibujo para principiantes nivel -1",
    teacher: "Puño",
    coverPath: "v1473938545/course-covers/000/000/138/138-original.jpg?1473938545",
  },
  {
    id: 114,
    title: "Lettering 3D: modelado y texturizado con Cinema 4D",
    teacher: "Zigor Samaniego",
    coverPath: "v1460468497/course-covers/000/000/114/114-original.jpg?1460468497",
  },
  {
    id: 236,
    title: "Introducción a las redes sociales para emprendedores creativos",
    teacher: "Pamela",
    coverPath: "v1519724656/course-covers/000/000/236/236-original.jpg?1519724656",
  },
  {
    id: 112,
    title: "Creación de una web profesional con WordPress",
    teacher: "Ignacio Cruz Moreno",
    coverPath: "v1461666095/course-covers/000/000/112/112-original.jpg?1461666095",
  },
  {
    id: 154,
    title: "Técnicas modernas de acuarela",
    teacher: "Ana Victoria Calderon",
    coverPath: "v1481800741/course-covers/000/000/154/154-original.jpg?1481800741",
  },
  {
    id: 469,
    title: "Estrategia de comunicación para redes sociales",
    teacher: "Núria Mañé",
    coverPath: "v1553174794/course-covers/000/000/469/469-original.jpg?1553174794",
  },
  {
    id: 181,
    title: "Animación exprés para redes sociales con After Effects",
    teacher: "Yimbo Escárrega",
    coverPath: "v1498070345/course-covers/000/000/181/181-original.jpg?1498070345",
  },
  {
    id: 266,
    title: "Autorretrato fotográfico artístico",
    teacher: "Cristina Otero",
    coverPath: "v1533556592/course-covers/000/000/266/266-original.jpg?1533556592",
  },
  {
    id: 262,
    title: "De principiante a superdibujante",
    teacher: "Puño",
    coverPath: "v1529661169/course-covers/000/000/262/262-original.jpg?1529661169",
  },
  {
    id: 171,
    title: "Producción y edición de vídeo con cámara DSLR y Adobe Premiere",
    teacher: "Gonzalo P. Martos",
    coverPath: "v1550502007/course-covers/000/000/171/171-original.jpg?1550502007",
  },
  {
    id: 347,
    title: "Ilustración digital con Procreate",
    teacher: "Óscar Lloréns",
    coverPath: "v1542698759/course-covers/000/000/347/347-original.jpg?1542698759",
  },
  {
    id: 178,
    title: "Freelance: claves y herramientas para triunfar siendo tu propio jefe",
    teacher: "Martina Flor",
    coverPath: "v1496042708/course-covers/000/000/178/178-original.jpg?1496042708",
  },
  {
    id: 227,
    title: "Fotografía profesional para Instagram",
    teacher: "Mina Barrio",
    coverPath: "v1515496215/course-covers/000/000/227/227-original.jpg?1515496215",
  },
];

const configDataset = document.querySelector(".js-search-form")?.dataset;
const container = document.querySelector("#js-search-form-box");
const config = { ...configDataset, noResultsCourses, container };

export default config;
